// Company stores (S3, 2026-10-12) — the frame for the public store pages
// (sign-off, join): no sign-in, no sidebar. The other lockup, a white top
// bar and the canvas background, the same as the signed-in portal.
import type { ReactNode } from "react";
import { Link } from "react-router-dom";

export function StorePublicShell({ children, narrow = false }: { children: ReactNode; narrow?: boolean }) {
  return (
    <div className="flex min-h-screen flex-col bg-canvas">
      <header className="flex h-[68px] items-center border-b border-rule bg-white px-4 md:px-8">
        <Link to="/login" aria-label="other — sign in">
          <img src="/brand/other-primary-lockup-black.svg" width={96} height={40} alt="other — merch. paper. gifts." draggable={false} />
        </Link>
      </header>
      <main className={`mx-auto w-full flex-1 px-4 py-10 md:px-8 ${narrow ? "max-w-md" : "max-w-[960px]"}`}>{children}</main>
      <footer className="px-4 pb-8 text-center text-xs text-muted md:px-8">Good work. Together. · other</footer>
    </div>
  );
}

/** A centred message card: a title, a line or two and an optional action. */
export function StoreNotice({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <section className="rounded-lg border border-rule bg-white p-8 text-center shadow-sm">
      <h1 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">{title}</h1>
      {children && <div className="space-y-3 text-sm text-brown-400">{children}</div>}
    </section>
  );
}

/** Grey box while a page loads. */
export function StoreLoading() {
  return (
    <div className="flex justify-center py-16">
      <div className="h-10 w-10 animate-pulse rounded-md bg-cream-300" aria-label="Loading" />
    </div>
  );
}
